// extracted by mini-css-extract-plugin
export default {"minicard":"MiniCard_minicard__I5kRc"};